import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { disableMockMode, isMockModeActive } from '@/services/mockAuth';

export function MockModeControls() {
    const navigate = useNavigate();
    const location = useLocation();
    const [isActive, setIsActive] = useState(isMockModeActive());

    useEffect(() => {
        setIsActive(isMockModeActive());
    }, [location.pathname]);

    if (!isActive) return null;

    const handleExit = () => {
        disableMockMode();
        setIsActive(false);
        navigate('/login');
    };

    return (
        <div className="fixed right-5 top-5 z-[100]">
            <Button
                type="button"
                variant="outline"
                onClick={handleExit}
                className="h-10 gap-2 border-red-200 bg-white px-4 text-red-700 shadow-lg hover:bg-red-50 hover:text-red-800"
            >
                <LogOut className="h-4 w-4" />
                Exit Mock Mode
            </Button>
        </div>
    );
}
